import CryptoJS from 'crypto-js'

import { CRYPTO_SECRET } from 'constants/crypto'

export function encrypt(value: string) {
  const encryptValue = CryptoJS.AES.encrypt(JSON.stringify(value), CRYPTO_SECRET).toString()
  return encryptValue
}
